import React, { useEffect, useState } from 'react';
import { api } from '../../app/Api/ApiSlice';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import InfiniteScroll from 'react-infinite-scroll-component';
import RequestedBranchCard from '../../components/RequestedBranchCard';

// requested to be parent orgs
const BranchesJoinRequested = () => {
    const [requestedBranches, setRequestedBranches] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);

    const { organization } = useParams();

    useEffect(() => {
        const getRequestedBranches = async () => {
            try {
                setIsLoading(true);
                const response = await api.get(`/${organization}/branches/requests/sent`, {
                    params: { page },
                });

                const newBranches = response.data.branchJoinRequests.sent;

                setRequestedBranches((prev) =>
                    page === 1 ? newBranches : [...prev, ...newBranches]
                );

                // If fewer items are returned than expected, assume no more pages
                if (newBranches.length === 0 || newBranches.length < 10) {
                    setHasMore(false);
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Something went wrong');
                setHasMore(false);
            } finally {
                setIsLoading(false);
            }
        };

        getRequestedBranches();
    }, [page, organization]);

    const handleRefresh = async () => {
        setPage(1);
        setHasMore(true);
    };

    return (
        <div>
            {<h2 className='page-header-title'>Sent Branch Join Requests</h2>}
            <InfiniteScroll
                dataLength={requestedBranches.length}
                next={() => setPage((prev) => prev + 1)}
                hasMore={hasMore}
                refreshFunction={handleRefresh}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
                pullDownToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↓ Pull down to refresh</h4>
                }
                releaseToRefreshContent={
                    <h4 style={{ textAlign: 'center' }}>↑ Release to refresh</h4>
                }
                loader={<Loader />}
            >
                {requestedBranches.length > 0 ? (
                    requestedBranches.map((b) => (
                        <div className="add-branch-container" key={b.id}>
                            <RequestedBranchCard b={b} />
                        </div>
                    ))
                ) : (
                    !isLoading && <p className='not-found-msg'>No organizations requested to be branches</p>
                )}
            </InfiniteScroll>
        </div>
    );
};

export default BranchesJoinRequested;
